import { Icons } from '@cast/design-system';

import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';
import FeatureLabel from './_components/FeatureLabel';

type SetupProps = Pick<
  AgentSetupBlockProps,
  'checked' | 'onChange' | 'hasBeenInstalled' | 'showCheckbox'
>;

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.security;
const icon = <Icons.CastSecurity variant="preset" weight="light" />;

export const AgentSecuritySetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Protect your cluster with real-time threat detection, vulnerability scanning, and proactive security measures"
      icon={icon}
      labelChip={<FeatureLabel />}
      testId="agent-security"
      {...props}
    />
  );
};

export const AgentSecurityComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      icon={icon}
      testId="agent-security-complete"
      checked={checked}
    />
  );
};
